import classNames from 'classnames'

import { RemoveButton } from 'core-components/library/multiSelect'
import { Tooltip } from 'core-components/library/tooltip'

import { IBaseTemplate } from './models/IBaseTemplate'

import styles from './BaseTemplate.module.scss'

export const BaseTemplate = <T,>({
  item,
  caption,
  onDeleteValue,
  multilineText,
  useDrag,
  compact,
  isRemoving,
  disabled,
  className = '',
  customValueRender,
  tooltipValue,
  __testId,
}: IBaseTemplate<T>) => {
  if (!item) {
    return null
  }

  const value = customValueRender || item[caption]

  return (
    <div
      className={classNames({
        [styles.item]: true,
        [styles.item__disabled]: disabled,
        [className]: !!className,
        [styles['item--draggable']]: useDrag,
      })}
    >
      {!compact ? (
        <span
          className={classNames(
            styles.item__text,
            multilineText ? styles.item__text_multiline : ''
          )}
        >
          {value}
        </span>
      ) : (
        <Tooltip
          className={styles.item__tooltip}
          disabled={tooltipValue === ''}
          tipContent={() => <div className={styles.tooltip}>{tooltipValue || value}</div>}
        >
          <span className={styles.item__tooltipText}>{value}</span>
        </Tooltip>
      )}

      <RemoveButton
        disabled={disabled}
        onClick={() => onDeleteValue(item)}
        isRemoving={isRemoving}
        __testId={`${__testId}-removeBtn`}
      />
    </div>
  )
}
